import { LineChart } from "lucide-react";
import { Panel, Stat } from "../trace/Primitives";
import { fmtPrice, fmtUsd, fmtNum, fmtPct } from "../../lib/trace";

const tone = (v) => (v === undefined || v === null ? "" : v >= 0 ? "text-trace-green" : "text-red-400");

export const MarketStats = ({ data }) => {
  const m = data.market;
  if (!m.available) {
    return (
      <Panel eyebrow={data.is_demo ? "Market data · DEMO placeholder" : "Market data · DexScreener"} title="Market" icon={LineChart} testId="market-stats-panel">
        <p className="text-sm text-trace-muted" data-testid="market-unavailable">
          No Solana trading pairs were found for this mint. Market data is unavailable.
        </p>
      </Panel>
    );
  }
  const pc = m.price_change || {};
  return (
    <Panel eyebrow={data.is_demo ? "Market data · DEMO placeholder" : "Market data · DexScreener"} title="Market" icon={LineChart} testId="market-stats-panel">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Stat label="Price" value={fmtPrice(m.price_usd)} sub={`1h ${fmtPct(pc.h1)} · 6h ${fmtPct(pc.h6)}`} testId="stat-price" />
        <Stat label="24h change" value={fmtPct(pc.h24)} tone={tone(pc.h24)} testId="stat-change-24h" />
        <Stat label="Market cap" value={fmtUsd(m.market_cap)} sub={`FDV ${fmtUsd(m.fdv)}`} testId="stat-market-cap" />
        <Stat label="24h volume" value={fmtUsd(m.volume_h24)} sub={`${m.pair_count} pair(s)`} testId="stat-volume" />
        <Stat label="Liquidity" value={fmtUsd(m.liquidity_usd_total)} testId="stat-liquidity" />
        <Stat label="24h buys" value={fmtNum(m.txns_h24.buys)} sub="main pair" testId="stat-buys" />
        <Stat label="24h sells" value={fmtNum(m.txns_h24.sells)} sub="main pair" testId="stat-sells" />
        <Stat label="First pair" value={m.first_pair_created_at ? new Date(m.first_pair_created_at).toLocaleDateString("en-GB") : "—"} testId="stat-first-pair" />
      </div>
    </Panel>
  );
};
